import { PartnerColors } from "./types";

export const DEFAULT_COLORS: PartnerColors = {
  // Primary brand colors
  primary: "green",
  primaryText: "#000",

  // Secondary colors
  secondary: "#000",
  secondaryText: "#fff",

  // Base colors
  black: "#000000",
  white: "#ffffff",

  // Semantic colors - modernized
  success: "#A7C838", // Brand lime-green
  successText: "#171717", // Dark text for WCAG AA contrast (lime-green fails with white)
  successLight: "#E8F0C1", // ~40% lighter variant
  successBorder: "#C3D87D", // ~20% lighter variant

  danger: "#ef4444", // Modern red instead of basic "red"
  dangerText: "#fff",
  dangerLight: "#fee2e2",
  dangerBorder: "#fca5a5",

  warning: "#f59e0b", // Refined orange
  warningText: "#fff",
  warningLight: "#fef3c7",
  warningBorder: "#fcd34d",

  info: "#3b82f6", // Modern blue instead of light blue
  infoText: "#fff",
  infoLight: "#dbeafe",
  infoBorder: "#93c5fd",

  // Modern gray scale (neutral tones)
  gray50: "#fafafa",
  gray100: "#f5f5f5",
  gray200: "#e5e5e5",
  gray300: "#d4d4d4",
  gray400: "#a3a3a3",
  gray500: "#737373",
  gray600: "#525252",
  gray700: "#404040",
  gray800: "#262626",
  gray900: "#171717",

  // Legacy gray mappings (for backward compatibility)
  gray1: "#fafafa",
  gray2: "#e5e5e5",
  gray3: "#d4d4d4",
  gray4: "#a3a3a3",
  gray5: "#a3a3a3",
  gray6: "#737373",
  gray7: "#737373",
  gray8: "#525252",
  gray9: "#525252",
  gray10: "#404040",
  gray11: "#262626",
  gray12: "#171717",

  // Semantic surface colors
  surface: "#ffffff",
  surfaceHover: "#fafafa",
  surfaceActive: "#f5f5f5",

  // Border colors
  border: "#e5e5e5",
  borderLight: "#f5f5f5",
  borderDark: "#d4d4d4",
  borderFocus: "#3b82f6", // Focus ring color

  // Text colors
  textColor: "#171717", // Slightly darker for better contrast
  textSecondary: "#525252",
  textTertiary: "#737373",
  textDisabled: "#a3a3a3",

  // Background colors
  background: "#ffffff",
  backgroundGray: "#fafafa", // Lighter, cleaner gray
  backgroundDark: "#f5f5f5",

  // Elevation/Shadow colors (used for rgba shadows)
  shadowColor: "0, 0, 0", // RGB values for use in rgba
};
